var Mustache = require("mustache");
import Swiper from "swiper";
import swiperA11y from "./utils/swiperA11y";
import breakpointChecker from "./utils/breakpointChecker";
import config from "./utils/config";

(function ($) {
  if ($(".page--AGI").length > 0) {
    $(document).on("click", ".expand__button", function () {
      $(this).next().toggleClass("content--collapse");
      $(this).toggleClass("button--expanded");
      let currentExpanded =
        $(this).attr("aria-expanded") == "true" ? true : false;
      $(this).attr("aria-expanded", !currentExpanded);
    });

    const syncTableCellHeight = (el_1, el_2, row, col) => {
      let height = 0;
      $(el_1 + " " + row).each(function (index) {
        var firstElementHeight = Math.max($(col, this).outerHeight(), height);
        var secondElementHeight = Math.max(
          $(
            el_2 + " " + row + ":nth-child(" + (index + 1) + ") " + col
          ).outerHeight(),
          height
        );
        var syncHeight = Math.max(firstElementHeight, secondElementHeight);
        console.log(syncHeight);
        $(el_1 + " " + row + ":nth-child(" + (index + 1) + ")").height(
          syncHeight + 18
        );
        $(el_2 + " " + row + ":nth-child(" + (index + 1) + ")").height(
          syncHeight + 18
        );
      });

      $(el_1).innerHeight(function () {
        return $(window).width() >= 992 ? height : "auto";
      });
      $(el_2).innerHeight(function () {
        return $(window).width() >= 992 ? height : "auto";
      });
    };

    const hideShowAxisX = (elementID) => {
      if (
        window.innerWidth <= 767 &&
        $(elementID + " .c3-axis.c3-axis-x g.tick").length > 11
      ) {
        $(elementID + " .c3-axis.c3-axis-x g.tick").each(function (index) {
          if (index % 2 != 0) {
            $(this).hide();
          }
        });
      } else {
        $(elementID + " .c3-axis.c3-axis-x g.tick").show();
      }
    };

    const insertDonut = () => {
      let GroupItemData = [];
      let GroupItem = [
        {
          Subgroup_2_val_eng: "",
          Subgroup_2_val_zhtw: "",
          Group_val_zhcn: "资讯技术 (64)",
          Subgroup_1_val_zhtw: "",
          Group_val_eng: "Information Technology (64)",
          Nav_per: 29.8,
          Subgroup_1_val_zhcn: "",
          Subgroup_2_val_zhcn: "",
          Group_val_zhtw: "資訊技術 (64)",
          Sub_nav_per_1: 0,
          Sub_nav_per_2: 0,
          Subgroup_1_val_eng: "",
        },
        {
          Subgroup_2_val_eng: "",
          Subgroup_2_val_zhtw: "",
          Group_val_zhcn: "金融 (72)",
          Subgroup_1_val_zhtw: "",
          Group_val_eng: "Financials (72)",
          Nav_per: 13,
          Subgroup_1_val_zhcn: "",
          Subgroup_2_val_zhcn: "",
          Group_val_zhtw: "金融 (72)",
          Sub_nav_per_1: 0,
          Sub_nav_per_2: 0,
          Subgroup_1_val_eng: "",
        },
        {
          Subgroup_2_val_eng: "",
          Subgroup_2_val_zhtw: "",
          Group_val_zhcn: "医疗保健 (64)",
          Subgroup_1_val_zhtw: "",
          Group_val_eng: "Health Care (64)",
          Nav_per: 12.5,
          Subgroup_1_val_zhcn: "",
          Subgroup_2_val_zhcn: "",
          Group_val_zhtw: "醫療保健 (64)",
          Sub_nav_per_1: 0,
          Sub_nav_per_2: 0,
          Subgroup_1_val_eng: "",
        },
        {
          Subgroup_2_val_eng: "",
          Subgroup_2_val_zhtw: "",
          Group_val_zhcn: "非核心消费 (53)",
          Subgroup_1_val_zhtw: "",
          Group_val_eng: "Consumer Discretionary (53)",
          Nav_per: 10.6,
          Subgroup_1_val_zhcn: "",
          Subgroup_2_val_zhcn: "",
          Group_val_zhtw: "非核心消費 (53)",
          Sub_nav_per_1: 0,
          Sub_nav_per_2: 0,
          Subgroup_1_val_eng: "",
        },
        {
          Subgroup_2_val_eng: "",
          Subgroup_2_val_zhtw: "",
          Group_val_zhcn: "通讯服务 (22)",
          Subgroup_1_val_zhtw: "",
          Group_val_eng: "Communication Services (22)",
          Nav_per: 8.9,
          Subgroup_1_val_zhcn: "",
          Subgroup_2_val_zhcn: "",
          Group_val_zhtw: "通訊服務 (22)",
          Sub_nav_per_1: 0,
          Sub_nav_per_2: 0,
          Subgroup_1_val_eng: "",
        },
        {
          Subgroup_2_val_eng: "",
          Subgroup_2_val_zhtw: "",
          Group_val_zhcn: "工业 (78)",
          Subgroup_1_val_zhtw: "",
          Group_val_eng: "Industrials (78)",
          Nav_per: 8.7,
          Subgroup_1_val_zhcn: "",
          Subgroup_2_val_zhcn: "",
          Group_val_zhtw: "工業 (78)",
          Sub_nav_per_1: 0,
          Sub_nav_per_2: 0,
          Subgroup_1_val_eng: "",
        },
        {
          Subgroup_2_val_eng: "",
          Subgroup_2_val_zhtw: "",
          Group_val_zhcn: "核心消费 (38)",
          Subgroup_1_val_zhtw: "",
          Group_val_eng: "Consumer Staples (38)",
          Nav_per: 6,
          Subgroup_1_val_zhcn: "",
          Subgroup_2_val_zhcn: "",
          Group_val_zhtw: "核心消費 (38)",
          Sub_nav_per_1: 0,
          Sub_nav_per_2: 0,
          Subgroup_1_val_eng: "",
        },
        {
          Subgroup_2_val_eng: "",
          Subgroup_2_val_zhtw: "",
          Group_val_zhcn: "能源 (23)",
          Subgroup_1_val_zhtw: "",
          Group_val_eng: "Energy (23)",
          Nav_per: 3.7,
          Subgroup_1_val_zhcn: "",
          Subgroup_2_val_zhcn: "",
          Group_val_zhtw: "能源 (23)",
          Sub_nav_per_1: 0,
          Sub_nav_per_2: 0,
          Subgroup_1_val_eng: "",
        },
        {
          Subgroup_2_val_eng: "",
          Subgroup_2_val_zhtw: "",
          Group_val_zhcn: "房地产 (31)",
          Subgroup_1_val_zhtw: "",
          Group_val_eng: "Real Estate (31)",
          Nav_per: 2.3,
          Subgroup_1_val_zhcn: "",
          Subgroup_2_val_zhcn: "",
          Group_val_zhtw: "房地產 (31)",
          Sub_nav_per_1: 0,
          Sub_nav_per_2: 0,
          Subgroup_1_val_eng: "",
        },
        {
          Subgroup_2_val_eng: "",
          Subgroup_2_val_zhtw: "",
          Group_val_zhcn: "原材料 (28)",
          Subgroup_1_val_zhtw: "",
          Group_val_eng: "Materials (28)",
          Nav_per: 2.3,
          Subgroup_1_val_zhcn: "",
          Subgroup_2_val_zhcn: "",
          Group_val_zhtw: "原材料 (28)",
          Sub_nav_per_1: 0,
          Sub_nav_per_2: 0,
          Subgroup_1_val_eng: "",
        },
        {
          Subgroup_2_val_eng: "",
          Subgroup_2_val_zhtw: "",
          Group_val_zhcn: "公用事业 (30)",
          Subgroup_1_val_zhtw: "",
          Group_val_eng: "Utilities (30)",
          Nav_per: 2.1,
          Subgroup_1_val_zhcn: "",
          Subgroup_2_val_zhcn: "",
          Group_val_zhtw: "公用事業 (30)",
          Sub_nav_per_1: 0,
          Sub_nav_per_2: 0,
          Subgroup_1_val_eng: "",
        },
      ];
      $.each(GroupItem, function (index, item) {
        let groupVal =
          document.documentElement.lang == "en"
            ? item["Group_val_eng"]
            : document.documentElement.lang == "zh-Hans"
            ? item["Group_val_zhcn"]
            : item["Group_val_zhtw"];
        let Nav_per = parseFloat(item.Nav_per);
        Nav_per = (Math.round(Nav_per * 1000000) / 1000000).toFixed(2);
        Nav_per = parseFloat(Nav_per);
        GroupItemData.push([groupVal, Nav_per]);
      });
      var data = GroupItemData;
      $(`#assetAllocation__0-container`).removeClass();
      $(`#assetAllocation__0-container`).addClass("c3js-chart");
      $(`#assetAllocation__0-container`).addClass("chart-type2");

      var chart = c3.generate({
        bindto: `#assetAllocation__0-container`,
        data: {
          columns: data,
          type: "donut",
        },
        size: {
          //width: window.innerWidth > 767 ? undefined : $(`.tab-content`).width() - 30,
          height: window.innerWidth > 767 ? 320 : 420,
        },
        legend: {
          position: window.innerWidth > 767 ? "right" : "bottom",
        },
        color: {
          pattern: [
            "#074240",
            "#007F84",
            "#4294AA",
            "#6E95D4",
            "#3F7D20",
            "#75A222",
            "#FB6107",
            "#C55507",
            "#B88B5D",
            "#517975",
            "#E7EBEB",
          ],
        },
        onresized: function () {
          console.log(chart.internal.config.legend_position);
          window.innerWidth > 767
            ? (chart.internal.config.legend_position = "right")
            : (chart.internal.config.legend_position = "bottom");
          //window.innerWidth > 767 ? chart.internal.config.size_height = 320 : chart.internal.config.size_width = 520
        },
      });
      //   $(document).on(
      //     "click",
      //     ".assetAllocation__container .dropdown-menu a",
      //     function () {
      //       setTimeout(function () {
      //         chart.flush();
      //       }, 650);
      //     }
      //   );
    };

    $(document).ready(function (e) {
      insertDonut();
      syncTableCellHeight(
        ".fundinformation__1 .fundinformation__item__first",
        ".fundinformation__1 .fundinformation__item__second",
        ".fundinformation__rows",
        ".fundinformation__value"
      );
      syncTableCellHeight(
        ".fundinformation__2 .fundinformation__item__first",
        ".fundinformation__2 .fundinformation__item__second",
        ".fundinformation__rows",
        ".fundinformation__value"
      );
    });
    $(window).resize(function () {
      // triggerResizeEvent()
      syncTableCellHeight(
        ".fundinformation__1 .fundinformation__item__first",
        ".fundinformation__1 .fundinformation__item__second",
        ".fundinformation__rows",
        ".fundinformation__value"
      );
      syncTableCellHeight(
        ".fundinformation__2 .fundinformation__item__first",
        ".fundinformation__2 .fundinformation__item__second",
        ".fundinformation__rows",
        ".fundinformation__value"
      );
    });
  }
})(hsvmJQuery);
